const TARGET_ELEMENT_WIDTH_RATIO = 0.8;
const MOBILE_VIEWPORT_WIDTH = 768;

const alignCenter = (containerSize, elementSize) => (containerSize - elementSize) / 2;

const getPositionByElement = (element, modalWidth, modalHeight) => {
  const { left, width } = element.getBoundingClientRect();
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const halfOfScreenWidth = screenWidth / 2;

  const offsetY = alignCenter(screenHeight, modalHeight);

  let offsetX;

  if (width > screenWidth * TARGET_ELEMENT_WIDTH_RATIO) {
    if (screenWidth < MOBILE_VIEWPORT_WIDTH) {
      offsetX = alignCenter(screenWidth, modalWidth);
    } else {
      offsetX = halfOfScreenWidth + alignCenter(halfOfScreenWidth, modalWidth);
    }

    return {
      offsetX,
      offsetY,
    };
  }

  if (left < halfOfScreenWidth) {
    offsetX = halfOfScreenWidth + alignCenter(halfOfScreenWidth, modalWidth);
  } else {
    offsetX = alignCenter(halfOfScreenWidth, modalWidth);
  }

  return {
    offsetX,
    offsetY,
  };
};

export default getPositionByElement;
